import { Component, Input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-stepper",
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: "./stepper.component.html",
  styleUrl: "./stepper.component.css",
})
export class StepperComponent {
  @Input() steps: string[] = [];
  @Input() currentStep: number = 0;
}
